import React from 'react';
import {MediaFile} from '../../../../data/models/LibraryFile/MediaFile';
import ImageWithFallback from '../../../../uiToolkit/ImageWithFallback/ImageWithFallback';
import {Icon} from '../../../../uiToolkit/Icon/Icon';
import PostReorderColumn from '../../components/PostReorderColumn';
import {postsText} from '../../postsText';
import styles from './PostMediaList.module.css';

interface Props {
  items: MediaFile[];
  onMove: (index: number, direction: 1 | -1) => void;
  onRemove: (fileId: string) => void;
}

const isVideoFile = (file: MediaFile) => file.fileType.startsWith('video');

const itemTitle = (file: MediaFile) => file.fileName.replace(/\.[^./]+$/, '');

const formatDuration = (seconds: number) => {
  const total = Math.round(seconds);
  const minutes = Math.floor(total / 60);
  const rest = total % 60;
  return `${minutes}:${rest.toString().padStart(2, '0')}`;
};

const PostMediaList = React.memo(({items, onMove, onRemove}: Props) => {
  return (
    <div className={styles.list}>
      {items.map((item, index) => {
        const isVideo = isVideoFile(item);
        return (
          <div className={styles.row} key={item.id}>
            <PostReorderColumn
              index={index}
              total={items.length}
              onMove={onMove}
            />
            <div className={styles.thumbnail}>
              {isVideo ? (
                item.placeholderUrl ? (
                  <ImageWithFallback
                    src={item.placeholderUrl}
                    className={styles.image}
                  />
                ) : (
                  <Icon name="video.svg" className={styles.fallbackIcon} />
                )
              ) : (
                <ImageWithFallback
                  src={item.fileUrl}
                  className={styles.image}
                />
              )}
              {isVideo && (
                <span className={styles.playBadge}>
                  <Icon name="play_ic.svg" className={styles.playIcon} />
                </span>
              )}
            </div>
            <div className={styles.info}>
              <p className={styles.title}>{itemTitle(item)}</p>
              <p className={styles.meta}>
                {isVideo
                  ? `${postsText.videoLabel} · ${formatDuration(
                      item.duration ?? 0,
                    )}`
                  : postsText.imageLabel}
              </p>
            </div>
            <div className={styles.actions}>
              <button
                className={styles.actionButton}
                onClick={() => onRemove(item.id)}
                title={postsText.remove}>
                <Icon name="trash-icon.svg" className={styles.actionIcon} />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
});

export default PostMediaList;
